<ap-dynforms [ngClass]="(showProgressBar$ | async) ? 'ap-login-in-progress' : ''" [fieldsets]="formConfig" (apSubmit)="onSubmit()" [display]="'inherit'">
  <div dynforms.after class="ap-login-dynforms-actions">
    <div class="ap-error" style="margin:0">
      <span id="login_error" *ngIf="(loginErrorMessage$ | async) != null && (loginErrorMessage$ | async).length > 0">{{(loginErrorMessage$ | async) | translateAsync | async}}</span>
      <ng-container *ngIf="(loginDelay$ | async) > 0">
        {{'Web_Login__WaitingPeriod' | translateAsync | async}}:
        <countdown [config]="{leftTime: (loginDelay$ | async) / 1000, format: 'HH:mm:ss'}"></countdown>
      </ng-container>
      <br>
      <a *ngIf="(loginErrorMessage$ | async) === 'Web_Login__AlreadyLoggedIn'" id="global_logout"
         (click)="globalLogout()"
         class="ap-btn-link"
      >{{'Global__Active_Users_Logout' | translateAsync | async}}</a>
    </div>
    <div class="ap-form-right ap-login-buttons">
      <div style="float: left; width: 40%">
        <a [routerLink]="[ApMenuUrls.LOGIN_PASSWORD_RESET]"
           id="passwordReset"
           class="ap-btn-link"
           data-cy="login_page_link_password_reset"
        >{{'PwRequest_Caption' | translateAsync | async}}
        </a>
      </div>
      <button
              id="button_login"
              class="k-button k-primary button-important"
              autofocus
              type="submit" kendoButton [primary]="true">{{'Lbl_Login' | translateAsync | async}}</button>
    </div>
    <div [class]="'ap-login-mobile-app-store-links'">
      <a href="https://play.google.com/store/apps/details?id=com.appinnovators.de.agriport_mobile" target="_blank">
        <img src="./assets/svg/google-play-store-logo.svg" alt="Google Play Store">
      </a>
      <a href="https://apps.apple.com/de/app/agriport/id6738807650" target="_blank">
        <img src="./assets/svg/apple-store-logo.svg" alt="Apple Store">
      </a>
    </div>
  </div>
  <div dynforms.action>
    <kendo-progressbar data-cy="login_page_progress_bar"  [label]="progressBarLabel" *ngIf="showProgressBar$ | async" [max]="maxProgress$ | async" [value]="actualProgress$ | async"></kendo-progressbar>
  </div>
</ap-dynforms>
